export default __webpack_public_path__ + "static/media/kansasCityCheifsVideo-2x.ec9670bd.jpg";